import { filtersByClients } from '@app/pages/Clients/ClientsList/data/filtersByClients';
import { filtersByVisits } from '@app/pages/Clients/ClientsList/data/filtersByVisits';

export { filtersByVisits, filtersByClients };
